module.exports = [{
  plugin: require('../../@mdx-deck/gatsby-plugin/gatsby-browser.js'),
  options: {
    "plugins": [],
    "path": "/home/runner/work/cncf-cloud-sustainability/cncf-cloud-sustainability/src/deck.mdx",
    "dirname": "/home/runner/work/cncf-cloud-sustainability/cncf-cloud-sustainability/src"
  }
}];